import { useMemo } from "react"

import { Obj, connect } from "scrivito"
import { WithChildren } from "shared/types/WithChildren"

import { ProductPageAddonTitlesContext } from "../context/ProductPageAddonTitlesContext"
import { useProductPageContext } from "../context/ProductPageContext"

function ProductPageAddonTitlesProviderComponent({ children }: WithChildren) {
  const { productObj } = useProductPageContext()

  const addons = (productObj
    ?.get("addons")
    .map((addon: Obj) => addon.get("addon"))
    .filter(Boolean) || []) as Obj<{ title: "string"; productType: "string" }>[]

  const titleByProductType = useMemo(
    () =>
      Object.fromEntries(
        addons.map(addon => [addon.get("productType"), addon.get("title")])
      ),
    [productObj]
  )

  const contextValue = useMemo(
    () => ({ titleByProductType }),
    [titleByProductType]
  )

  return (
    <ProductPageAddonTitlesContext.Provider value={contextValue}>
      {children}
    </ProductPageAddonTitlesContext.Provider>
  )
}

export const ProductPageAddonTitlesProvider = connect(
  ProductPageAddonTitlesProviderComponent
)
